import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  CircularProgress,
} from '@mui/material';
import authService from '../../services/authService';
import { logout } from '../../redux/auth/authSlice';

const ProfilePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(user);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    const loadProfile = async () => {
      try {
        setLoading(true);
        const data = await authService.getUserProfile();
        setProfile(data);
      } catch (e) {
        console.error('Failed to load profile', e);
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [isAuthenticated, navigate]);

  const handleLogout = async () => {
    try {
      await authService.logout();
    } finally {
      dispatch(logout());
      navigate('/');
    }
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 8, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          User Profile
        </Typography>

        {loading && (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress />
          </Box>
        )}

        {!loading && profile && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1">
              <strong>Name:</strong> {profile.first_name} {profile.last_name}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Email:</strong> {profile.email}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Country:</strong> {profile.country || '-'}
            </Typography>
            <Typography variant="subtitle1">
              <strong>City:</strong> {profile.city || '-'}
            </Typography>
            {profile.organization && (
              <>
                <Typography variant="subtitle1">
                  <strong>Organization:</strong> {profile.organization.name}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>Organization type:</strong> {profile.organization.type}
                  {profile.organization.custom_type
                    ? ` (${profile.organization.custom_type})`
                    : ''}
                </Typography>
              </>
            )}
            {profile.role && (
              <Typography variant="subtitle1">
                <strong>Role:</strong> {profile.role.name}
              </Typography>
            )}
          </Box>
        )}

        <Box display="flex" justifyContent="center" mt={4}>
          <Button variant="contained" color="secondary" onClick={handleLogout}>
            Logout
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default ProfilePage;

